import { Box } from 'modules/Box';
import { Typography } from 'modules/Typography';
export function MenuItemText(props) {
    const { primary, secondary, truncate } = props;
    return (<Box flexDirection="column">
      {primary && (<Typography $truncate={truncate} $appearance="300" $fontSize="small" $lineHeight="neutralized">
          {primary}
        </Typography>)}
      {secondary && (<Typography $truncate={truncate} $appearance="100" $fontSize="tiny" $lineHeight="neutralized">
          {secondary}
        </Typography>)}
    </Box>);
}
